import React, { Component } from 'react';
var axios = require('axios');
import { Redirect } from 'react-router-dom';
import baseUrl from '../baseUrl';
import './LoginPage.css';
// const baseUrl = 'http://localhost:4000';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      respStatus: '',
      respMessage: '',
      gotoindex: false,
      isLoading: false,
    };
  }
  goToIndex = () => {
    if (this.state.gotoindex === true) {
      return <Redirect to="/adminlist" />;
    }
  };
  handleSubmit = (event) => {
    this.setState({ isLoading: true });
    event.preventDefault();
    let loginData = {
      email: this.state.email,
      password: this.state.password,
    };
    axios.post(baseUrl + '/login', loginData).then((resp) => {
      console.log(resp);
      if (resp.data.message === 'Username or password is incorrect') {
        this.setState({ respStatus: false, respMessage: resp.data.message });
        setTimeout(() => {
          this.setState({ respStatus: '', gotoindex: false });
        }, 10000);
      } else {
        if (resp.data.message.user_status === 'Y') {
          if (resp.data.message.userType != 6) {
            if (
              resp.data.message.hash_new === undefined ||
              resp.data.message.hash_new === ''
            ) {
              localStorage.setItem('token', resp.data.message.token);
              localStorage.setItem('user_id', resp.data.message._id);
              localStorage.setItem('user_Type', resp.data.message.userType);
              localStorage.setItem('session_id', resp.data.session_id);
              localStorage.setItem('creditAmount', resp.data.creditAmount);
              this.setState({
                respStatus: true,
                respMessage: 'Login Successfully',
                email: '',
                password: '',
                isLoading: true,
              });
              setTimeout(() => {
                this.setState({
                  respStatus: '',
                  gotoindex: true,
                  isLoading: false,
                });
              }, 1000);
            } else {
              localStorage.setItem('token', resp.data.message.token);
              localStorage.setItem('user_id', resp.data.message._id);
              localStorage.setItem('user_Type', resp.data.message.userType);
              localStorage.setItem('session_id', resp.data.session_id);
              localStorage.setItem('change_password', 2);

              window.location.href = '/changepass';
              return false;
            }
          } else {
            this.setState({
              respMessage: 'Invalid Username And Password',
              respStatus: false,
            });
          }
        } else {
          this.setState({
            respStatus: false,
            respMessage: 'Something went wrong Please Contact upline',
          });
          return false;
          // window.location.href = '/login';
        }
      }
    }).finally(()=>this.setState({isLoading:false}));
  };
  handleChange = (event) => {
    let { name, value } = event.target;
    this.setState({ [name]: value });
  };

  responseHtml = () => {
    if (this.state.respStatus === false) {
      return <div className="alert alert-danger">{this.state.respMessage}</div>;
    } else if (this.state.respStatus === true) {
      return (
        <div className="alert alert-success">{this.state.respMessage}</div>
      );
    }
  };
  render() {
    var htmllogo1 = '';
    var html_logo2 = '';
    if ('admin.demandexch99.com' != window.location.hostname) {
      var htmllogo1 = (
        <img className="login_logo" src="/img/hari.png" alt="logo" />
      );
    }
    if ('admin.demandexch99.com' === window.location.hostname) {
      var html_logo2 = (
        <img className="login_logotwo" src="/img/demandexch99.png" alt="logo" />
      );
    }

    return (
      <div className="loginman">
        <div className="container">
          <div className="card card-login mx-auto mmt-12 border-none">
            {htmllogo1}
            <div className="card-header-1 sign-in-color">Sign In</div>
            <div className="card-body">
              <form
                className="form loginform mb-0"
                onSubmit={this.handleSubmit}
              >
                <div className="form-group">
                  <div className="form-label-group">
                    <input
                      type="text"
                      name="email"
                      placeholder="Username"
                      onChange={this.handleChange}
                      value={this.state.email}
                      className="form-control"
                      required="required"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-label-group">
                    <input
                      type="password"
                      name="password"
                      id="inputPassword"
                      placeholder="Password"
                      onChange={this.handleChange}
                      value={this.state.password}
                      className="form-control"
                      required="required"
                    />
                  </div>
                </div>
                {/* <div className="form-group">
						<div className="checkbox">
						  <label>
							<input name="remember" type="checkbox" value="1"/> 
							Remember Me
						  </label>
						</div>
					  </div>*/}
                {this.goToIndex()}
                {this.responseHtml()}
                <div className=" form-label-group">
                  <button type="submit" className="btn man_btn width-100">
                    Login{' '}
                    {this.state.isLoading ? (
                      <i
                        className="fa fa-spinner fa-spin fa-fw text-white"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className=" ml-2 fas fa-sign-in-alt"></i>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="copy_right">© DEVA ONLINE BOOK</div>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.js